

import Breadcrumb from "../../components/Breadcrumb/Breadcrumb.js";
import BowlerAveragesTable from "../../components/BowlerAveragesTable/BowlerAveragesTable.js";
import TournamentSubpageHead from "../../components/SEO/TournamentSubpageHead";
import { useTournamentId, useTournamentSlug } from "../../context/TournamentRouteContext";
import { tournamentPath } from "../../utility/tournamentUrls";

export default function Results() {
  const tournamentId = useTournamentId();
  const tournamentSlug = useTournamentSlug();

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Tournaments", path: "/tournaments" },
    { label: "[Tournament Name]", path: tournamentPath(tournamentSlug) },
    { label: "Averages" },
  ];

  return (
    <>
      <TournamentSubpageHead page="averages" />
      <div className="flex justify-center mb-3 sm:mb-4 px-4 sm:px-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <BowlerAveragesTable tournamentId={tournamentId} />
    </>
  );
}
